<template>
  <div>
    <template v-if="pupInfo">
      <el-card shadow="never">
        <h4>This a new place with the following name</h4>
        <el-input
            placeholder="Name of place"
            v-model="PUPCOM.changePickTo"
            clearable></el-input>
        <h4>
          <small>in that case</small>
          the place is (probably) in the following area
        </h4>
        <s-form-item label="Location" :sz="12">
          <s-remote-select
              v-model="PUPCOM.relLoc"
              class-model="locations"
              query-prop="q"
              label-prop="name"></s-remote-select>
        </s-form-item>
        <s-form-item label="Exc.Meeting Point" :sz="12">
          <s-remote-select
              v-model="PUPCOM.relMeetingPoint"
              class-model="pup"
              :extra-query-params="{type:5}"
              query-prop="q"
              label-prop="name"></s-remote-select>
        </s-form-item>
        <s-form-item label="Type" :sz="6">
          <s-remote-select
              queryProp="q"
              classModel="puptypes"
              v-model="PUPCOM.type"
              labelProp="title"
              valueProp="id"></s-remote-select>
        </s-form-item>
        <s-form-item label="Email" :sz="14">
          <el-input v-model="PUPCOM.email"></el-input>
        </s-form-item>
        <!--        <el-input-->
        <!--            placeholder="Location name"-->
        <!--            v-model="PUPCOM.changePickTo"-->
        <!--            clearable></el-input>-->

        <s-form-item label="Learn It " :sz="4">
          <sf-button
              :disabled="!PUPCOM.relLoc"
              type="primary"
              @click="handlePup(true)" material="add">
            New location
          </sf-button>
        </s-form-item>


      </el-card>
      <el-divider><h2>Or</h2></el-divider>
      <el-card shadow="never">
        <h4>Is a misspelling of the following place?</h4>

        <s-remote-select
            v-model="PUPCOM.changePickToExisted"
            class-model="pup"
            query-prop="q"
            :limit="5000"
            sortField="order"
            label-prop="name"
            caption-field="loc_name"
            prefix-field="typename"
            :extraQueryParams="{matchlocPup:pupInfo.ppname,matchLoc:pupInfo.resort,limit:0}">
          <template slot-scope="{item}">
            <span :style="item.order<10000?'font-weight:bold':''">{{ item.name }}</span>
            <el-tag type="info">{{ item.loc_name }}</el-tag>
          </template>
        </s-remote-select>
        <sf-button
            :disabled="!PUPCOM.changePickTo"
            type="primary"
            @click="handlePup()">
          Remember it just for this case
        </sf-button>
        <sf-button
            type="success"
            :disabled="!PUPCOM.changePickTo"
            @click="handlePup(false,true)">
          Remember it and learn it as a synonim
        </sf-button>
      </el-card>
    </template>
    <el-card v-if="pupData">
      <s-form :fill-height="false">
        <s-form-item label="Name">
          <el-input v-model="pupData.name"></el-input>
        </s-form-item>
        <s-form-item label="Location" :sz="18">
          <s-remote-select
              v-model="pupData.location"
              class-model="locations"
              query-prop="q"
              label-prop="name"></s-remote-select>
        </s-form-item>
        <s-form-item label="Type" :sz="6">
          <s-remote-select
              queryProp="q"
              classModel="puptypes"
              v-model="pupData.type"
              labelProp="title"
              valueProp="id"></s-remote-select>
        </s-form-item>
        <s-form-item label="Email" :sz="14">
          <el-input v-model="pupData.email"></el-input>
        </s-form-item>
        <s-form-item label="Phone" :sz="10">
          <el-input v-model="pupData.phone"></el-input>
        </s-form-item>
        <s-form-actions>
          <sf-button type="warning" material="close" style="float: left" slot="left"></sf-button>
          <sf-button type="success" material="check" style="float: right" @click="updatePup"></sf-button>
        </s-form-actions>
      </s-form>
    </el-card>
  </div>
</template>

<script>
import * as api from "~/api/resource";
import {getObject} from "../../api/resource";
import SRemoteSelect from "./SRemoteSelect.vue";

export default {
  name: "s-pupresolver",
  components: {SRemoteSelect},
  props: {
    newObject: {type: Object, default: () => null},
    pupInfo: {type: Object, default: () => null},
    forFileId: {default: null},
    value: {default: null},
  },
  data() {
    return {PUPCOM: {}, pupData: null};
  },
  methods: {
    async handlePup(isNew, isSynonim) {
      if (isNew) this.PUPCOM.isNew = true;
      if (isSynonim) this.PUPCOM.isSynonim = true;

      const {data} = await api.fetchProcessor("pup/fullupdate", {
        ...this.PUPCOM,
        file: this.forFileId,
        limit: 0,
        sort: "ppid",
      });
      this.$emit("done",this.pupInfo);

    },
    async updatePup() {

      const {data} = await api.fetchProcessor("pup/update", this.pupData);

      this.$emit('change', data.object)
      this.$emit('input', data.object)
      this.$emit("done",this.pupInfo);

    },
  },
  watch: {
    value: {
      immediate: true,
      async handler(v, ov) {
        if (v != ov) {
          if (v) {
            if (_.isObject(v))
              this.pupData = v
            else
              this.pupData = await getObject('pup', v)
          }
        }
        // this.PUPCOM.changePickTo = v.ppname;
      },
    },
    "pupInfo.ppname": {
      immediate: true,
      async handler(v, ov) {
        if (v != ov) {
          this.$set(this.PUPCOM, "changePickTo", v);
          this.$set(this.PUPCOM, "changePickFrom", v);
          //this.PUPCOM.changePickFrom=
        }
        // this.PUPCOM.changePickTo = v.ppname;
      },
    },

    "pupInfo.resort": {
      immediate: true,
      async handler(v, ov) {
        if (v != ov) {
          var data = await api.getModxList("locations", {name: v});
          if (data && data[0]) this.$set(this.PUPCOM, "relLoc", data[0].id);
          _log_("data..", data);
        }
      },
    },

    // pupInfo: {
    //   async handler(v) {
    //     PUPCOM.changePickTo=v.ppname
    //     if(v.resort)
    //   },
    //   deep: true
    // }
  },
};
</script>
